var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-plus';
                    var viewUrl = 'sprite.svg#view-icon-plus';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-plus#icon-plus';
                            viewUrl = 'sprite.svg?icon-plus#view-icon-plus';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 17.3 17.3',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };